import React from "react";
import ContactForm from "../components/ContactForm";
import HeroBanner from "../components/HeroBanner";
import Aboutbanner from "../assets/images/Aboutbanner.png";
import RealEstateOverview from "../components/RealEstateOverview";
import FAQ from "../components/FAQ";
import RealStateTransactions from "../components/RealStateTransactions";
import Invertors from "../components/Invertors";

const AboutUsPage = () => {
  const bannerimg = Aboutbanner;
  const tittle = "About "

  const aboutData = {

    heading: "The Real Estate Transaction Defragmented, Demystified and Democratized",
    content:
      "BASE is the future of buying and selling real estate entirely using a mobile app. Sellers save their equity with 0% Commissions!! That's right, we are a commission free platform so you keep more of what your house is worth.",


    contentTwo: "The entire transaction is completed through the app with direct P2P interaction with the buyer and seller. No more pesky realtors getting in between and making things complicated. BASE users are verified and the platform allows for secure transactions from end to end. Paperwork will be a breeze using simple forms and e-sign formats. BASE takes you by the hand through our Journey feature so you always know what's next and our specialists are available at any time to assist you through the process. Welcome to the future."

  };

  return <div>
    <HeroBanner bannerimg={bannerimg} tittle={tittle} />
    <RealEstateOverview aboutData={aboutData} btnshown={false} />
    <RealStateTransactions />
    <FAQ />
    <Invertors />
    <ContactForm />
  </div>;
};

export default AboutUsPage;
